import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { LOOP_COLORS, styled } from '../../../lib/stitches'
import { useTreeState } from '../../../stores/Root'
import { Row } from '../../core/Components'
import { ChevronDown, ChevronUp } from '../../core/icons/icons'
import withTooltip from '../../core/withTooltip'
import { blue1, gray3 } from '../../platform/color'
import EmptySelectedContainer from '../../studio/selectedcontainer/EmptySelectedContainer'

const MARGIN = '20px'
const BUTTON_SIZE = '20px'
export const LOOP_HEIGHT = '75px'

const DropdownButtonBody = styled(Row, {
  minWidth: BUTTON_SIZE,
  maxWidth: BUTTON_SIZE,
  minHeight: BUTTON_SIZE,
  maxHeight: BUTTON_SIZE,
  backgroundColor: blue1,
  borderRadius: '100%',
  cursor: 'pointer',
  transition: '100ms',
  position: 'absolute',
  top: MARGIN,
  right: '0px',
  '&:hover': { opacity: '70%' }
})

interface DropdownButtonProps {
  onClick: () => void
  isExpanded: boolean
}

const StyledDropdownButton: FC<DropdownButtonProps> = ({ onClick, isExpanded }) => {
  const size = '16px'
  return (
    <DropdownButtonBody onClick={() => onClick()} verticalCenter horizontalCenter>
      {isExpanded ? (
        <ChevronDown width={size} height={size} />
      ) : (
        <ChevronUp width={size} height={size} />
      )}
    </DropdownButtonBody>
  )
}

const DropdownButton = withTooltip(StyledDropdownButton, 'top')

interface Props {
  stemIndex: number
}

const LoopSelector: FC<Props> = ({ stemIndex }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const { studio } = useTreeState()
  const stem = studio.song.stems[stemIndex]
  const currentLoop = stem.getLoopAtSectionOrNull(studio.selectedSection)

  return (
    <Row
      css={{
        borderTop: `1px solid ${gray3}`,
        paddingTop: MARGIN,
        paddingRight: BUTTON_SIZE,
        marginTop: MARGIN,
        maxHeight: !isExpanded ? BUTTON_SIZE : LOOP_HEIGHT,
        marginBottom: isExpanded && MARGIN,
        position: 'relative',
        flex: 1
      }}
      animateAppear
    >
      {(isExpanded || !currentLoop) && (
        <EmptySelectedContainer
          loopColor={
            ArpRegistry.readyForStudioUse && LOOP_COLORS[stem.colorIndex % LOOP_COLORS.length]
          }
          stemIndex={stemIndex}
        />
      )}
      {currentLoop && (
        <DropdownButton
          onClick={() => setIsExpanded(!isExpanded)}
          isExpanded={isExpanded}
          tooltipText={isExpanded ? 'Hide Loops' : 'Show Loops'}
        />
      )}
    </Row>
  )
}

export default observer(LoopSelector)
